import CashFlowReport from './CashFlowReport.js';
import StudentReport from './StudentReport.js';

const reportMap = {
  CashFlowReport,
  StudentReport,
};

function Report ({ reportTemplate, reportData = {} }) {
  const _Report = reportMap[reportTemplate];
  if (!_Report) {
    return <div>Report "{reportTemplate}" not found.</div>;
  }

  return <_Report  reportData={reportData}/>
};

export default Report;